import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  duration,
  easing,
  size,
} from '@twistopayments/design-system/styles'

export const root = (theme: Theme) => css`
  display: block;
  text-decoration: none;
  outline: 2px solid ${theme.palette.tertiary.lowContrast};
  border-radius: ${theme.borderRadius.md};
  cursor: pointer;
  transition: box-shadow ${easing.easeInOut} ${duration.standard}ms;
  height: 100%;
  padding: clamp(${size[20]}, 5vw, ${size[32]});

  &:hover {
    outline: 1px solid ${theme.palette.tertiary.upperMediumContrast};
    box-shadow: ${theme.shadows.boxHover};
  }
`

export const icon = (theme: Theme) => css`
  width: clamp(${size[24]}, 1vw + ${size[20]}, ${size[32]});
  height: clamp(${size[24]}, 1vw + ${size[20]}, ${size[32]});
  margin-bottom: ${size[12]};
  color: ${theme.palette.text.title};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[16]};
  }

  svg {
    width: 100%;
    height: auto;
  }
`

export const headline = css`
  margin-bottom: ${size[4]};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[8]};
  }
`
